<template>
  <div>
    <div style="margin-bottom: 16px; text-align: center">
      <a-radio-group v-model="langMode" button-style="solid" @change="handleLangModeChange">
        <a-radio-button value="en">Just English</a-radio-button>
        <a-radio-button value="es">Just Spanish</a-radio-button>
        <a-radio-button value="both">Show Both</a-radio-button>
      </a-radio-group>
    </div>
    <IntroVideoWorkspace v-if="showEn" key="welcome-en" type="welcome" language="en" />
    <IntroVideoWorkspace v-if="showEs" key="welcome-es" type="welcome" language="es" />
  </div>
</template>

<script>
import IntroVideoWorkspace from '../introVideoWorkspace';
import UserService from '@/services/UserService';
import { mapGetters } from 'vuex';

export default {
  components: {
    IntroVideoWorkspace,
  },
  data() {
    return {
      langMode: 'en',
      userEmail: '',
    };
  },
  computed: {
    ...mapGetters(['user']),
    showEn() {
      return this.langMode === 'en' || this.langMode === 'both';
    },
    showEs() {
      return this.langMode === 'es' || this.langMode === 'both';
    },
  },
  async mounted() {
    await this.initializeLangMode();
  },
  methods: {
    async initializeLangMode() {
      try {
        // Get user info to initialize langMode from show_mode
        const userInfo = await UserService.doGetUserInfo1();
        if (userInfo.show_mode !== undefined) {
          // Map show_mode values: 0=English, 1=Spanish, 2=Both
          const modeMap = { 0: 'en', 1: 'es', 2: 'both' };
          this.langMode = modeMap[userInfo.show_mode] || 'both';
        }
        this.userEmail = userInfo.email;
      } catch (error) {
        console.error('Failed to initialize language mode:', error);
        // Default to 'both' if there's an error
        this.langMode = 'both';
      }
    },
    async handleLangModeChange(e) {
      try {
        // Map radio values to show_mode: English=0, Spanish=1, Both=2
        const modeMap = { en: 0, es: 1, both: 2 };
        const selected = e && e.target ? e.target.value : this.langMode;
        const showMode = modeMap[selected];

        // Update the user's show_mode in the database
        await UserService.updateShowMode(showMode, this.userEmail);

        // Update local user state if needed
        if (this.user && this.user.user) {
          this.$store.dispatch('user/updateUser', {
            user: { ...this.user.user, show_mode: showMode },
          });
        }
      } catch (error) {
        console.error('Failed to update show mode:', error);
        // Revert the selection if update fails
        this.langMode = this.getPreviousLangMode();
        this.$message.error('Failed to update language preference. Please try again.');
      }
    },
    getPreviousLangMode() {
      // Get the previous value from user state or default to 'both'
      if (this.user && this.user.user && this.user.user.show_mode !== undefined) {
        const modeMap = { 0: 'en', 1: 'es', 2: 'both' };
        return modeMap[this.user.user.show_mode] || 'both';
      }
      return 'both';
    },
  },
};
</script>
